var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main pwa-default-body",class:{'gradient': _vm.backgroundGradient},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }